import { WrapText } from 'components/common/wrap-text/WrapText';
import { useTariffHighlightFeatures } from 'components/direct-sales/quote/hooks/useTariffFeatures';

import type { TProduct } from 'api/models/TProduct';

type Props = {
  product: TProduct;
  maxWrap?: number;
};

export const testId = 'tariffHighlight';

export const TariffHighlight = ({ product, maxWrap }: Props) => {
  const highlightFeatures: TProduct['features'] = useTariffHighlightFeatures(
    product
  );

  if (!highlightFeatures?.length) return null;

  return highlightFeatures.map((feature, index) => (
    <div className="h6 p-small" key={index} data-testid={testId}>
      <b>
        <WrapText wrap={!!maxWrap} max={maxWrap}>
          {feature.description || ''}
        </WrapText>
      </b>
    </div>
  ));
};
